import axios from "axios";

const apiUrl = `${process.env.REACT_APP_API_URL}/payment`;
const token = localStorage.getItem("token");

// Création d'une session Stripe pour un plan tarifaire
export const createCheckoutSessionForPlan = async (plan, userId) => {
  const token = localStorage.getItem("token");
  if (!token) {
    throw new Error("Utilisateur non authentifié. Veuillez vous connecter.");
  }

  try {
    const response = await axios.post(
      `${apiUrl}/create-checkout-session/plan`,
      {
        role_id: plan.role_id,
        formule: plan.formule, // Formule associée au plan
        price: plan.price.replace("€", "").trim(), // Convertir le prix au format attendu
        product_id: plan.product_id, // Ajout du product_id
        user_id: userId, // Envoi explicite du userId
      },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`, // En-tête pour l'authentification
        },
      }
    );
    return response.data.url; // Retourne l'URL Stripe Checkout
  } catch (error) {
    console.error(
      "Erreur lors de la création de la session de paiement pour un plan :",
      error
    );
    throw error;
  }
};


// export const createCheckoutSessionForInscriptions = async (
//   items,
//   paymentPlan
// ) => {
//   try {
//     const response = await axios.post(
//       `${apiUrl}/create-checkout-session/inscriptions`,
//       { items, paymentPlan },
//       {
//         headers: {
//           "Content-Type": "application/json",
//           Authorization: `Bearer ${token}`,
//         },
//       }
//     );
//     return response.data.url;
//   } catch (error) {
//     console.error(
//       "Erreur lors de la création de la session de paiement pour les inscriptions:",
//       error
//     );
//     throw error;
//   }
// };

// export const verifyPayment = async (sessionId) => {
//   try {
//     const response = await axios.post(
//       `${apiUrl}/verify-payment`,
//       { sessionId },
//       {
//         headers: {
//           "Content-Type": "application/json",
//           Authorization: `Bearer ${token}`,
//         },
//       }
//     );
//     return response.data;
//   } catch (error) {
//     console.error("Erreur lors de la vérification du paiement:", error);
//     throw error;
//   }
// };
